import { getObjectEntries } from '@hg-akademie-ban/vamos-viva-type-utils';
import { Box, Typography } from '@mui/material';
import { Link } from 'react-router';

import { url } from '../../../appRouter/url';
import { type AkaDurchgangId, type VivaStatus } from '../../../dtos';
import { sortVivaStatus } from '../../../utils/sortVivaStatus';
import { durchgangListingSnackbarsContent as content } from './DurchgangListing.snackbars.content';

type DurchgangStatusChangeResult = {
  akaDurchgangId: AkaDurchgangId;
  status: VivaStatus;
  successMessages: string[];
  errorMessages: {
    akaVeranstaltungId?: string;
    message: string;
  }[];
};

export const generateDurchgangListingSuccessSnackbar = (durchgaenge: DurchgangStatusChangeResult[]) => {
  const groupedDurchgaengeByStatus = Object.groupBy(durchgaenge, (durchgang) => durchgang.status);
  const additional = getObjectEntries(groupedDurchgaengeByStatus)
    .toSorted(([statusA], [statusB]) => sortVivaStatus(statusA, statusB))
    .map(([status, durchgaenge]) => (durchgaenge ? content.successMessages[status](durchgaenge.length) : ''))
    .join(' ');

  return {
    message: content.successTitle,
    options: {
      variant: 'success',
      additional,
    },
  } as const;
};

export const generateDurchgangListingErrorSnackbar = ({
  failedDurchgaenge: durchgaenge,
  newStatus,
  openLinksInNewTab,
}: {
  failedDurchgaenge: DurchgangStatusChangeResult[];
  newStatus: VivaStatus;
  openLinksInNewTab: boolean;
}) => {
  const errorMessage = content.errorMessages[newStatus](durchgaenge.length);

  const linkTarget = openLinksInNewTab ? '_blank' : '_self';
  return {
    message: content.errorTitle,
    options: {
      variant: 'error',
      persist: true,
      additional: (
        <Box>
          <Typography>{errorMessage}</Typography>
          <ul>
            {durchgaenge.map((durchgang) => (
              <li key={durchgang.akaDurchgangId}>
                <strong>
                  <Link to={url.durchgang.details(durchgang.akaDurchgangId)} target={linkTarget} rel="noopener">
                    {durchgang.akaDurchgangId}
                  </Link>
                </strong>
                <ul>
                  {durchgang.errorMessages.map((error) => (
                    <li key={error.akaVeranstaltungId}>
                      {error.akaVeranstaltungId && (
                        <>
                          <Link
                            to={url.durchgang.detailsForModultermin(durchgang.akaDurchgangId, error.akaVeranstaltungId)}
                            target={linkTarget}
                            rel="noopener"
                          >
                            {error.akaVeranstaltungId}
                          </Link>
                          {': '}
                        </>
                      )}
                      {error.message}
                    </li>
                  ))}
                </ul>
              </li>
            ))}
          </ul>
        </Box>
      ),
    },
  } as const;
};
